import moment from "moment";
import {
  methods,
  methodsAr,
  methodsBo,
  methodsBr,
  methodsCl,
  methodsCo,
  methodsDo,
  methodsEs,
  methodsMx,
  methodsPa,
  methodsPeru,
  methodsVe,
  methodsGt,
  methodsPy,
} from "../const/payment-methods";

export const isMobile = () => {
  if (
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)
  )
    return true;
  return false;
};

export const compare = (item, toCompare) => {
  if (item.hipodromo.toLowerCase().includes(toCompare.toLowerCase()))
    return true;
  if (item.nombre)
    if (item.nombre.toLowerCase().includes(toCompare.toLowerCase()))
      return true;
  if (item.carrera.toLowerCase().includes(toCompare.toLowerCase())) return true;
  if (item.tipo)
    if (item.tipo.toLowerCase().includes(toCompare.toLowerCase())) return true;
  if (item.moneda.toLowerCase().includes(toCompare.toLowerCase())) return true;
  if (item.id_venta.includes(toCompare)) return true;
  if (item.monto.includes(toCompare)) return true;
  if (item.monto_premio.includes(toCompare)) return true;
  return false;
};
export const getEstado = (item) => {
  let estado = "";
  if (parseInt(item.ganador) === 2) {
    estado = "paid";
  } else if (parseInt(item.retirado) === 2) {
    estado = "pending";
  } else {
    if (parseFloat(item.monto_premio) > 0 || parseInt(item.ganador) === 1) {
      if (parseFloat(item.monto_premio) > 0) {
        estado = "winner";
      } else {
        estado = "verifying";
      }
    } else if (parseInt(item.retirado) === 1) {
      estado = "retired";
    } else {
      if (item.hasOwnProperty("monto_devolucion")) {
        if (
          parseFloat(item.monto_premio) === 0 &&
          parseFloat(item.monto_devolucion) === 0 &&
          parseInt(item.estado) === 0
        ) {
          estado = "loser";
        } else {
          if (parseInt(item.estado) === 1 && parseInt(item.perdido) === 0) {
            estado = "current";
          } else {
            if (parseFloat(item.monto_devolucion) < parseFloat(item.monto)) {
              estado = "partial";
            } else {
              if (
                parseFloat(item.monto_devolucion) === parseFloat(item.monto)
              ) {
                if (parseInt(item.estado) === 0) {
                  estado = "canceled";
                } else {
                  estado = "retired";
                }
              }
            }
          }
        }
      } else {
        if (
          parseFloat(item.monto_premio) === 0 &&
          parseInt(item.estado === 0)
        ) {
          estado = "loser";
        } else {
          if (parseInt(item.estado) === 1 && parseInt(item.perdido) === 0) {
            estado = "current";
          }
        }
      }
    }
  }

  return estado;
};
export const formarJugadaWps = ({ tipo, monto, cantidad }) =>
  `${tipo} => ${parseFloat(monto).toFixed(2)} [Cant. ${parseFloat(
    cantidad
  ).toFixed(2)}]`;
export const getNumberHorseColor = (numero) => {
  numero = parseInt(numero);
  let val = "";
  switch (numero) {
    case 1:
      val = { background: "#B60101" };
      break;
    case 2:
      val = { background: "#F7F6F6", color: "#000" };
      break;
    case 3:
      val = { background: "#104E83" };
      break;
    case 4:
      val = { background: "#D1D103" };
      break;
    case 5:
      val = { background: "#015D01" };
      break;
    case 6:
      val = { background: "#232323" };
      break;
    case 7:
      val = { background: "#B5711E" };
      break;
    case 8:
      val = { background: "#BB9198" };
      break;
    case 9:
      val = { background: "#186DA9" };
      break;
    case 10:
      val = { background: "#800080" };
      break;
    case 11:
      val = { background: "#6C6B6B" };
      break;
    case 12:
      val = { background: "#239723" };
      break;
    case 13:
      val = { background: "#62209E" };
      break;
    case 14:
      val = { background: "#808000" };
      break;
    case 15:
      val = { background: "#ada96e" };
      break;
    case 16:
      val = { background: "#2b547e" };
      break;
    case 17:
      val = { background: "navy" };
      break;
    case 18:
      val = { background: "#4e9258" };
      break;
    case 19:
      val = { background: "#c2dfff" };
      break;
    default:
      val = { background: "#F7F6F6", color: "#000" };
      break;
  }
  return val;
};

export const arrName = (i) => {
  if (i === 0) return "first";
  if (i === 1) return "second";
  if (i === 2) return "third";
  if (i === 3) return "fourth";
  if (i === 4) return "fifth";
  if (i === 5) return "sixth";
};

export const getCombinaciones = (
  tipo,
  arrayFirst,
  arraySecond,
  arrayThird,
  arrayFourth,
  arrayFifth,
  arraySixth,
  primeraCarrera = "",
  segundaCarrera = "",
  terceraCarrera = "",
  cuartaCarrera = "",
  quintaCarrera = "",
  sextaCarrera = "",
  septimaCarrera = "",
  octavaCarrera = ""
) => {
  let first = "";
  let second = "";
  let third = "";
  let fourth = "";
  let fifth = "";
  let sixth = "";

  switch (tipo) {
    case "exacta":
      arrayFirst = arrayFirst.sort(function (a, b) {
        return a - b;
      });
      first = arrayFirst.join("-");
      arraySecond = arraySecond.sort(function (a, b) {
        return a - b;
      });
      second = arraySecond.join("-");
      return first + " / " + second;

    case "trifecta":
      arrayFirst = arrayFirst.sort(function (a, b) {
        return a - b;
      });
      first = arrayFirst.join("-");
      arraySecond = arraySecond.sort(function (a, b) {
        return a - b;
      });
      second = arraySecond.join("-");
      arrayThird = arrayThird.sort(function (a, b) {
        return a - b;
      });
      third = arrayThird.join("-");
      return first + " / " + second + " / " + third;

    case "superfecta":
      arrayFirst = arrayFirst.sort(function (a, b) {
        return a - b;
      });
      first = arrayFirst.join("-");
      arraySecond = arraySecond.sort(function (a, b) {
        return a - b;
      });
      second = arraySecond.join("-");
      arrayThird = arrayThird.sort(function (a, b) {
        return a - b;
      });
      third = arrayThird.join("-");
      arrayFourth = arrayFourth.sort(function (a, b) {
        return a - b;
      });
      fourth = arrayFourth.join("-");
      return first + " / " + second + " / " + third + " / " + fourth;

    case "pick2":
      arrayFirst = arrayFirst.sort(function (a, b) {
        return a - b;
      });
      first = arrayFirst.join("-");
      arraySecond = arraySecond.sort(function (a, b) {
        return a - b;
      });
      second = arraySecond.join("-");
      return (
        "●" +
        primeraCarrera +
        " => " +
        first +
        "<br/>●" +
        segundaCarrera +
        " => " +
        second
      );
    case "pick3":
      arrayFirst = arrayFirst.sort(function (a, b) {
        return a - b;
      });
      first = arrayFirst.join("-");
      arraySecond = arraySecond.sort(function (a, b) {
        return a - b;
      });
      second = arraySecond.join("-");
      arrayThird = arrayThird.sort(function (a, b) {
        return a - b;
      });
      third = arrayThird.join("-");
      return (
        "●" +
        primeraCarrera +
        " => " +
        first +
        "<br/>●" +
        segundaCarrera +
        " => " +
        second +
        "<br/>●" +
        terceraCarrera +
        " => " +
        third
      );
    case "pick4":
      arrayFirst = arrayFirst.sort(function (a, b) {
        return a - b;
      });
      first = arrayFirst.join("-");
      arraySecond = arraySecond.sort(function (a, b) {
        return a - b;
      });
      second = arraySecond.join("-");
      arrayThird = arrayThird.sort(function (a, b) {
        return a - b;
      });
      third = arrayThird.join("-");
      arrayFourth = arrayFourth.sort(function (a, b) {
        return a - b;
      });
      fourth = arrayFourth.join("-");
      return (
        "●" +
        primeraCarrera +
        " => " +
        first +
        "<br/>●" +
        segundaCarrera +
        " => " +
        second +
        "<br/>●" +
        terceraCarrera +
        " => " +
        third +
        "<br/>●" +
        cuartaCarrera +
        " => " +
        fourth
      );
    case "pick5":
      arrayFirst = arrayFirst.sort(function (a, b) {
        return a - b;
      });
      first = arrayFirst.join("-");
      arraySecond = arraySecond.sort(function (a, b) {
        return a - b;
      });
      second = arraySecond.join("-");
      arrayThird = arrayThird.sort(function (a, b) {
        return a - b;
      });
      third = arrayThird.join("-");
      arrayFourth = arrayFourth.sort(function (a, b) {
        return a - b;
      });
      fourth = arrayFourth.join("-");
      arrayFifth = arrayFifth.sort(function (a, b) {
        return a - b;
      });
      fifth = arrayFifth.join("-");
      return (
        "●" +
        primeraCarrera +
        " => " +
        first +
        "<br/>●" +
        segundaCarrera +
        " => " +
        second +
        "<br/>●" +
        terceraCarrera +
        " => " +
        third +
        "<br/>●" +
        cuartaCarrera +
        " => " +
        fourth +
        "<br/>●" +
        quintaCarrera +
        " => " +
        fifth
      );
    case "pick6":
      arrayFirst = arrayFirst.sort(function (a, b) {
        return a - b;
      });
      first = arrayFirst.join("-");
      arraySecond = arraySecond.sort(function (a, b) {
        return a - b;
      });
      second = arraySecond.join("-");
      arrayThird = arrayThird.sort(function (a, b) {
        return a - b;
      });
      third = arrayThird.join("-");
      arrayFourth = arrayFourth.sort(function (a, b) {
        return a - b;
      });
      fourth = arrayFourth.join("-");
      arrayFifth = arrayFifth.sort(function (a, b) {
        return a - b;
      });
      fifth = arrayFifth.join("-");
      arraySixth = arraySixth.sort(function (a, b) {
        return a - b;
      });
      sixth = arraySixth.join("-");
      return (
        "●" +
        primeraCarrera +
        " => " +
        first +
        "<br/>●" +
        segundaCarrera +
        " => " +
        second +
        "<br/>●" +
        terceraCarrera +
        " => " +
        third +
        "<br/>●" +
        cuartaCarrera +
        " => " +
        fourth +
        "<br/>●" +
        quintaCarrera +
        " => " +
        fifth +
        "<br/>●" +
        sextaCarrera +
        " => " +
        sixth
      );

    default:
      break;
  }
};

export const formatDate = (date) => {
  const m = moment(date);
  let fecha = m.fromNow();
  const [num, tiempo, ago] = fecha.split(" ");
  let temp = "";
  if (ago === "ago") temp = "Hace " + num;
  if (num === "a" || num === "an") temp = "Hace 1";
  if (tiempo === "days") temp = temp + " dias";
  if (tiempo === "day") temp = temp + " dia";
  if (tiempo === "hours") temp = temp + " horas";
  if (tiempo === "hour") temp = temp + " hora";
  if (tiempo === "minutes") temp = temp + " minutos";
  if (tiempo === "minute") temp = temp + " minuto";
  if (tiempo === "seconds") temp = temp + " segundos";
  if (tiempo === "second") temp = temp + " segundo";
  if (tiempo === "months") temp = temp + " meses";
  if (tiempo === "month") temp = temp + " mes";
  if (tiempo === "years") temp = temp + " años";
  if (tiempo === "year") temp = temp + " año";
  return temp;
};

export const getEstadoHistorial = (estado) => {
  if (estado === "0" || estado === "11")
    return { title: "En Espera", clase: "waiting", msg: false };
  if (estado === "01" || estado === "1")
    return { title: "Procesado", clase: "primary", msg: false };
  if (estado === "02" || estado === "2")
    return { title: "Rechazado", clase: "reject", msg: false };
  if (estado === "03" || estado === "3")
    return { title: "Rechazado", clase: "reject", msg: false };
  if (estado === "04" || estado === "4")
    return { title: "Rechazado", clase: "reject", msg: true };
};

export const formatNumber = (e) => {
  let value = e.target.value;
  value = value.replace(/\D/g, "");
  value = value.replace(/(\d)(\d{2})$/, "$1,$2");
  value = value.replace(/(?=(\d{3})+(\D))\B/g, ".");
  e.target.value = value;
  return e;
};

export const getEstadoBono = (estado) => {
  if (estado === "1") return { title: "activo", clase: "primary" };
  if (estado === "2") return { title: "verificacion", clase: "warning" };
  if (estado === "3") return { title: "vencido", clase: "dark" };
  if (estado === "4") return { title: "cancelado", clase: "danger" };
  if (estado === "7") return { title: "aplicado", clase: "success" };
  if (estado === "8") return { title: "autenticacion", clase: "success" };
};

export const toLocale = (num) => {
  return num.toLocaleString("de-DE", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
};

export const returnImage = (Image, Game, GameTitle) => {
  if (typeof Game === "string" && Game.includes("https")) {
    console.log("aca paso la imagen 1 ", Image, Game, GameTitle);
    let nameImageGolden = "";
    switch (GameTitle) {
      case "Book Of Eon":
      case "Betrick":
      case "Boat Trip Mississippi":
      case "Gold Diggers":
      case "Scratch or Treat":
        nameImageGolden = "./images/spinmatic/" + GameTitle + ".jpg";
        break;
      case "9 Masks of Voodoo":
      case "3 Amigos":
      case "Baby Blue":
      case "Bank Run":
      case "Betrick Scratch":
      case "Bingo Machine":
      case "Bingooo":
      case "Book of Bastet Deluxe":
      case "Boss Vegas":
      case "Buffalo Boost":
      case "Caishens Treasure":
      case "Calico Jack":
      case "Code 243-0":
      case "Copper Diggers":
      case "Cosmo Mix":
      case "Danza De Los Muertos":
      case "Ed Jones and Book Of Bastet - Xtreme Deluxe":
      case "Ed Jones and Book of Seth Xtreme":
      case "Ed Jones and Book Of Seth":
      case "Egyptian Stones":
      case "Ekeko":
      case "El Fuego":
      case "Fairy Dust Xtreme":
      case "Fairy Dust":
      case "Fall Of The Beast":
      case "Fancy Jungle":
      case "Fortune Dynasty":
      case "Freeway":
      case "Fruit Cube":
      case "Fruit Farm":
      case "Fruit Monster Christmas":
      case "Fruit Monster":
      case "Fruity Beats - Xtreme":
      case "FRUITY BEATS":
      case "Galacnica Xmas":
      case "Galacnica":
      case "Gift From Santa Blue":
      case "Gift From Santa Green":
      case "Gift From Santa Red":
      case "Haunted Chateau":
      case "Helio Luna Revenge":
      case "Holly Molly Hole":
      case "Infectus":
      case "Jelly Teddy":
      case "Krampus":
      case "Lama Glama":
      case "Love Balloon":
      case "Love Birds":
      case "Madame Moustache":
      case "Mafioso Deluxe":
      case "Mafioso":
      case "Mahala":
      case "Mayanera Return":
      case "Meteoroid Crash":
      case "Meteoroid Deluxe":
      case "MoonScratch":
      case "Mr. Hat Before The Sunrise":
      case "Mr. Hat Sunshine":
      case "Need For Space":
      case "NiceCream":
      case "Patanjali Chakra":
      case "Pinky Plinko":
      case "Plata O Plomo Deluxe":
      case "Plata O Plomo":
      case "Poseidon Xtreme":
      case "Poseidon":
      case "Real Life Super Hero Lite":
      case "Real Life Super Heroes Bonus":
      case "RoboLand":
      case "Rooster":
      case "Rose Mary":
      case "Shaolin Twins":
      case "Silver Diggers":
      case "Sizzling Blaze Deluxe":
      case "Sizzling Blaze Jackpot":
      case "Sizzling Blaze":
      case "Sizzling Neon Jackpot":
      case "Space Oddity":
      case "SpinCircus":
      case "Spring Invaders":
      case "Starbatch":
      case "Sushi House":
      case "Synthway":
      case "The Golden Egg":
      case "The GoldenEgg Easter":
      case "WhatTheDuck":
      case "Wild Cat":
      case "Wild Valentines Xmas":
      case "Wild Valentines":
      case "World Of Gods - Niflheim":
      case "Zombcity":
        nameImageGolden = "./images/spinmatic/" + GameTitle + ".png";
        break;
      default:
        nameImageGolden = Game;
        break;
    }
    return nameImageGolden;
  }

  // if(typeof Game==='string' && Game.includes('https')) return Game

  let nameImage = "";
  switch (Image) {
    case "Queen of Gods":
    case "Spirit of Adventure":
      nameImage = "/images/pragmatic/" + Image + ".svg";
      break;
    case "Spaceman":
      nameImage = "/images/pragmatic/spaceman.png";
      break;
    case "Bomb Bonanza":
    case "Sugar Rush":
      nameImage =
        "https://api-br0.pragmaticplay.net/game_pic/square/200/" +
        Game +
        ".png";
      break;
    case "Cosmic Cash":
      nameImage =
        "https://api-br0.pragmaticplay.net/game_pic/square/200/" +
        Game +
        ".png";
      break;
    case "Shining Hot 5":
    case "Shining Hot 20":
    case "Shining Hot 40":
    case "Shining Hot 100":
    case "Big Bass Splash":
    case "Eye of Cleopatra":
    case "Cash Patrol":
    case "Zombie Carnival":
    case "Fortune of Giza":
    case "Wild West Gold Megaways":
    case "Cleocatra":
    case "Goblin Heist Powernudge":
    case "Chicken Chase":
    case "Clover Gold":
    case "Little Gem Hold and Spin":
    case "5 Lions Megaways 2":
    case "Ancient Island Megaways":
    case "Aztec Treasure Hunt":
    case "Big Bass Baboiu' din Deltă":
    case "Big Bass Halloween II":
    case "Big Bass Vegas Double Down Deluxe":
    case "Big Bass Xmas Xtreme":
    case "Bigger Bass Splash":
    case "Book of Monsters":
    case "Congo Cash XL":
    case "Eternal Empress Freeze Time":
    case "Floating Dragon Year of the Snake":
    case "Gates of Olympus 1000 Dice":
    case "Gravity Bonanza":
    case "Greedy Wolf":
    case "Hand of Midas 2":
    case "Happy Hooves":
    case "Heart of Cleopatra":
    case "Heist for the Golden Nugget":
    case "Hellvis Wild":
    case "Heroic Spins":
    case "Himalayan Wild":
    case "Hot Pepper":
    case "Hot to Burn 7 Deadly Free Spins":
    case "Hot to Burn Extreme":
    case "Hot to Burn Multiplier":
    case "Ice Lobster":
    case "Infective Wild":
    case "Jackpot Hunter":
    case "Jasmine Dreams":
    case "Jewel Rush":
    case "John Hunter & the Quest for Bermuda Riches":
    case "John Hunter and Galileo's Secrets":
    case "John Hunter and the Book of Tut Respin":
    case "Joker's Jewels Dice":
    case "Joker's Jewels Hot":
    case "Joker's Jewels Wild":
    case "Juicy Fruits Multihold":
    case "Kingdom of the Dead":
    case "Knight Hot Spotz":
    case "Lamp Of Infinity":
    case "Lobster Bob's Crazy Crab Shack":
    case "Lobster Bob's Sea Food and Win It":
    case "Loki's Riches":
    case "Lucky Grace & Charm Mega Hold & Spin":
    case "Lucky Lightning":
    case "Lucky's Wild Pub":
    case "Magic Money Maze":
    case "Mammoth Gold Megaways":
    case "Medusa's Stone":
    case "Might of Freya Megaways":
    case "Might of Ra":
    case "Mighty Munching Melons":
    case "Mochimon":
    case "Moleionaire":
    case "Money Stacks":
    case "Muertos Multiplier Megaways":
    case "Mustang Gold Megaways":
    case "Mustang Trail":
    case "Mystery Mice":
    case "Mystic Chief":
    case "Nile Fortune":
    case "North Guardians":
    case "Octobeer Fortunes":
    case "Oodles of Noodles":
    case "Penguins Christmas Party Time":
    case "Piggy Bank Bills":
    case "Piggy Bankers":
    case "Pinup Girls":
    case "Pirate Golden Age":
    case "Pirates Pub":
    case "Pompeii Megareels Megaways":
    case "Pot Of Fortune":
    case "Power of Merlin Megaways":
    case "Pub Kings":
    case "Raging Waterfall Megaways":
    case "Ratinho Sortudo":
    case "Release The Bison":
    case "Savannah Legend":
    case "Sweet Baklava":
    case "Sweet Bonanza 1000 Dice":
    case "The Dog House Royal Hunt":
    case "Touro Sortudo":
    case "Triple Pot Goldd":
    case "Volcano Goddess":
    case "Wild Wild Joker":
      nameImage = "/images/pragmatic/" + Image + ".gif";
      break;
    default:
      nameImage =
        "https://api-br0.pragmaticplay.net/game_pic/square/200/" +
        Game +
        ".png";
      break;
  }

  return nameImage;
};

export const returnImageTVBET = (name, thumbnail) => {
  let nameImage = "";
  switch (name) {
    case "tvbet_1bet":
    case "tvbet_5bet":
    case "tvbet_7bet":
    case "tvbet_andarbahar":
    case "tvbet_blackjack":
    case "tvbet_fastkeno":
    case "tvbet_keno":
    case "tvbet_lucky6":
    case "tvbet_poker":
    case "tvbet_war":
    case "tvbet_wheel":
    case "tvbet_roulette":
      nameImage = "/images/tvbet_new/" + name + ".jpg";
      break;
    default:
      nameImage = thumbnail;
      break;
  }

  return nameImage;
};

export const estadoTicket = (item) => {
  let estado = "";
  if (item.ganador === "2") {
    estado = "paid";
  } else if (item.betType === "INH") {
    estado = "ticketInh";
  } else {
    if (item.ganador === "1") {
      estado = "winner";
    } else if (item.retirado === "1") {
      estado = "retired";
    } else {
      if (item.perdido === "1") {
        estado = "loser";
      } else {
        if (item.estado === "1" && item.perdido === "0") {
          estado = "current";
        } else {
          if (item.estado === "0") {
            estado = "canceled";
          }
        }
      }
    }
  }
  return estado;
};

export const formatCurrency = (moneda, user = null) => {
  switch (moneda) {
    case "Bs.S":
      if (user && user.toLowerCase() === "usuarioa") return "UND";
      return "VES";
    case "$":
      return "USD";
    case "Sol":
      return "PEN";
    default:
      return moneda;
  }
};

export const formatTipoPago = (value) => {
  if (value === "SOLICITUD DEPOSITO") return "SOLICITUD DEPÓSITO";
  return value;
};

export const getFormattedDate = (fecha, hora) => {
  const fechaBackend = new Date(`${fecha} ${hora} GMT-0400`);

  const fechaLocal = fechaBackend.toLocaleString("es-ES", {
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone, // Detecta la zona horaria del usuario automáticamente
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  return fechaLocal.split(", ");
};

export const formatInteger = (e) => {
  let value = e.target.value;
  value = value.replace(/\D/g, "");
  e.target.value = value;
  return e;
};

export const toLocaleString = (num) => {
  return num.toLocaleString("de-DE");
};

export const comprobarTiempoInactivo = (date) => {
  const storedMoment = moment(date);

  const currentMoment = moment();

  // ya cumplio el tiempo de inactividad
  if (currentMoment.isAfter(storedMoment)) return true;

  // sigue inactivo
  return false;
};

export const getPaymentMethods = (pais) => {
  const metodos = {
    PE: methodsPeru,
    VE: methodsVe,
    BR: methodsBr,
    CL: methodsCl,
    AR: methodsAr,
    CO: methodsCo,
    BO: methodsBo,
    MX: methodsMx,
    DO: methodsDo,
    PA: methodsPa,
    ES: methodsEs,
    GT: methodsGt,
    PY: methodsPy,
  };
  return metodos[pais] || methods;
};

export const permitirGuardarFavorito = (currency, op) => {
  const paymentMethods = {
    "bs.s": ["transferencia", "pago movil"],
    cop: ["transferencia", "nequi", "otros"],
    sol: ["transferencia", "yape", "plin"],
    eur: ["transferencia", "bizum"],
    clp: ["transferencia"],
    ars: ["transferencia"],
    dop: ["transferencia"],
    $: [
      "transferencia",
      "paypal",
      "zelle",
      "zinli",
      "yappy",
      "nequi",
      "usdt (binance pay)",
      "usdt (billetera)",
    ],
    mxn: ["oxxo", "transferencia"],
  };

  const allowedMethods = paymentMethods[currency.toLowerCase()];
  if (!allowedMethods) {
    return false;
  }
  return allowedMethods.includes(op.toLowerCase());
};

export const getFormFavoritos = (detalleString) => {
  const detalleArray = detalleString.split("=");
  const moneda = detalleArray[0].toLowerCase();
  const tipoOperacion = detalleArray[1].toLowerCase();

  const formFields = {};
  switch (moneda) {
    case "bs.s":
      if (tipoOperacion === "transferencia") {
        formFields.bancoNombre = detalleArray[2];
        formFields.tipoCuenta = detalleArray[3];
        formFields.numeroCuenta = detalleArray[4];
        formFields.nombreApellido = detalleArray[5];
        formFields.cedula = detalleArray[6];
      } else if (tipoOperacion === "pago movil") {
        formFields.bancoNombre = detalleArray[2];
        formFields.numeroCuenta = detalleArray[3];
        formFields.nombreApellido = detalleArray[4];
        formFields.cedula = detalleArray[5];
      }
      break;
    case "cop":
      if (tipoOperacion === "transferencia") {
        formFields.bancoNombre = detalleArray[2];
        formFields.tipoCuenta = detalleArray[3];
        formFields.numeroCuenta = detalleArray[4];
        formFields.nombreApellido = detalleArray[5];
        formFields.cedula = detalleArray[6];
      } else if (tipoOperacion === "nequi") {
        formFields.numeroCuenta = detalleArray[2];
        formFields.nombreApellido = detalleArray[3];
      } else if (tipoOperacion === "otros") {
        formFields.nombreApellido = detalleArray[2];
        formFields.cedula = detalleArray[3];
      }
      break;

    case "sol":
      if (tipoOperacion === "transferencia") {
        formFields.bancoNombre = detalleArray[2];
        formFields.tipoCuenta = detalleArray[3];
        formFields.numeroCuenta = detalleArray[4];
        formFields.nombreApellido = detalleArray[5];
        formFields.cedula = detalleArray[6];
      } else if (tipoOperacion === "yape" || tipoOperacion === "plin") {
        formFields.numeroCuenta = detalleArray[2];
        formFields.nombreApellido = detalleArray[3];
      }
      break;

    case "eur":
      if (tipoOperacion === "transferencia") {
        formFields.bancoNombre = detalleArray[2];
        formFields.numeroCuenta = detalleArray[3];
        formFields.nombreApellido = detalleArray[4];
        formFields.cedula = detalleArray[5];
      } else if (tipoOperacion === "bizum") {
        formFields.numeroCuenta = detalleArray[2];
        formFields.nombreApellido = detalleArray[3];
      }
      break;

    case "clp":
    case "ars":
    case "dop":
      if (tipoOperacion === "transferencia") {
        formFields.bancoNombre = detalleArray[2];
        formFields.tipoCuenta = detalleArray[3];
        formFields.numeroCuenta = detalleArray[4];
        formFields.nombreApellido = detalleArray[5];
        formFields.cedula = detalleArray[6];
      }
      break;

    case "$":
      if (tipoOperacion === "transferencia") {
        formFields.bancoNombre = detalleArray[2];
        formFields.tipoCuenta = detalleArray[3];
        formFields.numeroCuenta = detalleArray[4];
        formFields.nombreApellido = detalleArray[5];
        formFields.cedula = detalleArray[6];
      } else if (
        ["paypal", "zelle", "zinli", "yappy", "nequi"].includes(tipoOperacion)
      ) {
        formFields.numeroCuenta = detalleArray[2];
        formFields.nombreApellido = detalleArray[3];
      } else if (tipoOperacion === "usdt (binance pay)") {
        formFields.numeroCuenta = detalleArray[2];
      } else if (tipoOperacion === "usdt (billetera)") {
        formFields.numeroCuenta = detalleArray[2];
        formFields.bancoNombre = detalleArray[3];
      }
      break;

    case "mxn":
      if (tipoOperacion === "oxxo") {
        formFields.numeroCuenta = detalleArray[2];
        formFields.nombreApellido = detalleArray[3];
      } else if (tipoOperacion === "transferencia") {
        formFields.bancoNombre = detalleArray[2];
        formFields.tipoCuenta = detalleArray[3];
        formFields.numeroCuenta = detalleArray[4];
        formFields.nombreApellido = detalleArray[5];
        formFields.cedula = detalleArray[6];
      }
      break;
    default:
      break;
  }

  return formFields;
};

/* export const searchCountryCode = (codcountry) => {
    // Usa una expresión regular para encontrar el código de país
    const codigoPais = codcountry.match(/^\+\d{1,3}/);
    // Si se encuentra un código de país, lo retorna

    let btnNumber = "";
    let btnNumbertext = "";

    if (codigoPais == "+591") {
      btnNumber = "BO";
      btnNumbertext = "+591";
    }
    if (codigoPais == "+507") {
      btnNumber = "PA";
      btnNumbertext = "+507";
    }

    if (codigoPais == "+56") {
      btnNumber = "CL";
      btnNumbertext = "+56";
    }
    if (codigoPais == "+593") {
      btnNumber = "EC";
      btnNumbertext = "+593";
    }
    if (codigoPais == "+34") {
      btnNumber = "ES";
      btnNumbertext = "+34";
    }
    if (codigoPais == "+51") {
      btnNumber = "PE";
      btnNumbertext = "+51";
    }

    if (codigoPais == "+58") {
      btnNumber = "VE";
      btnNumbertext = "+58";
    }
    if (codigoPais == "+57") {
      btnNumber = "CO";
      btnNumbertext = "+57";
    }

    if (codigoPais == "+54") {
      btnNumber = "AR";
      btnNumbertext = "+54";
    }
    if (codigoPais == "+55") {
      btnNumber = "BR";
      btnNumbertext = "+55";
    }
    if (codigoPais == "+52") {
      btnNumber = "MX";
      btnNumbertext = "+52";
    }
    if (codigoPais == "+1") {
      btnNumber = "DO";
      btnNumbertext = "+1";
    }
    if (codigoPais == "+502") {
      btnNumber = "GT";
      btnNumbertext = "+502";
    }
    if (codigoPais == "+595") {
      btnNumber = "PY";
      btnNumbertext = "+595";
    }

    return {btnNumber, btnNumbertext}
  }; */

export const searchCountryCode = (codcountry) => {
  const codigoPaisMatch = codcountry.match(/^\+\d{1,3}/);
  const codigoPais = codigoPaisMatch ? codigoPaisMatch[0] : "";

  const countryMap = {
    "+591": "BO",
    "+507": "PA",
    "+56": "CL",
    "+593": "EC",
    "+34": "ES",
    "+51": "PE",
    "+58": "VE",
    "+57": "CO",
    "+54": "AR",
    "+55": "BR",
    "+52": "MX",
    "+1": "DO",
    "+502": "GT",
    "+595": "PY",
  };

  const btnNumber = countryMap[codigoPais] || "";
  const btnNumbertext = btnNumber ? codigoPais : "";

  return { btnNumber, btnNumbertext };
};

export const getCountryName = (countryval) => {
  let countryname = "";
  switch (countryval) {
    case "AR":
      countryname = { name: "Argentina", code: "+54", flag: "AR" };
      break;
    case "BO":
      countryname = { name: "Bolivia", code: "+591", flag: "BO" };
      break;
    case "BR":
      countryname = { name: "Brasil", code: "+55", flag: "BR" };
      break;
    case "CL":
      countryname = { name: "Chile", code: "+56", flag: "CL" };
      break;
    case "CO":
      countryname = { name: "Colombia", code: "+57", flag: "CO" };
      break;
    case "EC":
      countryname = { name: "Ecuador", code: "+593", flag: "EC" };
      break;
    case "ES":
      countryname = { name: "España", code: "+34", flag: "ES" };
      break;
    case "MX":
      countryname = { name: "Mexico", code: "+52", flag: "MX" };
      break;
    case "PA":
      countryname = { name: "Panamá", code: "+507", flag: "PA" };
      break;
    case "PE":
      countryname = { name: "Perú", code: "+51", flag: "PE" };
      break;
    case "DO":
      countryname = { name: "Rep. Dominicana", code: "+1", flag: "DO" };
      break;
    case "VE":
      countryname = { name: "Venezuela", code: "+58", flag: "VE" };
      break;
    case "GT":
      countryname = { name: "Guatemala", code: "+502", flag: "GT" };
      break;
    case "PY":
      countryname = { name: "Paraguay", code: "+595", flag: "PY" };
      break;
    default:
      countryname = { name: "Argentina", code: "+54", flag: "AR" };
      break;
  }

  return countryname;
};
